import BaseModel from '../core/BaseModel'
export default class DocumentLangModel extends BaseModel {

    constructor() {
        super({
                name: "document_lang",
                tableName: 'document_lang',
                label: "document_lang",
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                id_lang: {
                    name: 'id_lang',
                    type: "String",
                    label: 'id_lang',
                },
                document_id: {
                    name:'document_id',
                    label:'Document category',
                   
                },
                description: {
                    name:'description',
                    label:'Property',
                },
                name : {
                    name:'name',
                    label:'Name',
                },
            })
    }

}